import { Form } from "@circle-react-shared/uikit/Form";
import type { Editor } from "@tiptap/core";
import { omit } from "lodash";
import type { Ref } from "react";

import { useCanMarkPurchaseFlow } from "@/react/helpers/purchaseFlowAnchor";

import { ButtonFormActions } from "./ButtonFormActions";
import { ButtonFormFields } from "./ButtonFormFields";
import { insertCTA } from "./insertCTA";
import { getValidationSchema } from "./validationSchema";

interface ButtonFormProps {
  defaultValues: {
    color: string;
    label: string;
    may_lead_to_purchase?: boolean;
    text_color: string;
    url: string;
  };
  editor: Editor;
  formId?: string;
  hideActions?: boolean;
  inputRef: Ref<HTMLInputElement>;
  isWithinEmailEditor?: boolean;
  onClose: () => void;
  range: {
    from: number;
    to: number;
  };
}

export const ButtonForm = ({
  inputRef,
  editor,
  range,
  onClose,
  defaultValues,
  isWithinEmailEditor,
  formId,
  hideActions = false,
}: ButtonFormProps) => {
  const isEdit = !!defaultValues.label;
  const canMarkPurchaseFlow = useCanMarkPurchaseFlow();

  return (
    <Form
      id={formId}
      defaultValues={defaultValues}
      onSubmit={attrs => {
        insertCTA({
          editor,
          range,
          attrs: canMarkPurchaseFlow
            ? attrs
            : omit(attrs, "may_lead_to_purchase"),
          isEdit,
          isWithinEmailEditor,
        });
        onClose();
      }}
      validationSchema={getValidationSchema(isWithinEmailEditor)}
      shouldStopPropagation
      noValidate
    >
      <ButtonFormFields
        inputRef={inputRef}
        isWithinEmailEditor={isWithinEmailEditor}
      />
      {!hideActions && <ButtonFormActions onClose={onClose} />}
    </Form>
  );
};
